class StorePicker extends HTMLElement {
  constructor() {
    super();
    // Create Shadow DOM
    this.attachShadow({ mode: "open" });

    // Store data configuration - 8 German cities with associated product variant IDs
    this.stores = this.getPickupPointData();

    // Component state
    this.selectedStore = null;
    this.map = null;
    this.markers = [];
  }

  connectedCallback() {
    this.render();
    this.loadGoogleMaps();
    this.setupEventListeners();
  }

  // Render component
  render() {
    // CSS styles for the component
    const style = document.createElement("style");
    style.textContent = `
        :host { display: block; width: 100%; height: 100%; font-family: var(--font-body-family); }
        
        .store-picker-container {
          display: flex;
          width: 100%;
          height: 100%;
          min-height: 500px;
        }
        
        .store-list { 
          width: 280px; 
          flex-shrink: 0;
          padding: 10px; 
          overflow-y: auto; 
          box-sizing: border-box; 
          background-color: #ffffff; 
        }
        
        .map-container { 
          flex: 1; 
          min-width: 0;
          position: relative;
          height: 100%; 
        }
        
        /* 移动端样式 */
        @media (max-width: 768px) {
          .store-picker-container {
            flex-direction: column;
           
          }
          
          .store-list {
            width: 100%;
            height: 40vh;
            min-height: 300px;
            order: 2;
            border-top: 1px solid #e0e0e0;
          }
          
          .map-container {
            height: 60vh;
            min-height: 300px;
            order: 1;
          }
          
          #map {
            border-radius: 0;
          }
        }
        
        #map { 
          position: absolute;
          top: 0;
          left: 0;
          width: 100%; 
          height: 100%; 
        }
        
        .store-item { 
          position: relative;
          background: #FFF9E9; 
          border-radius: 8px; 
          padding: 15px; 
          margin-bottom: 15px; 
          box-shadow: 0 1px 3px rgba(0,0,0,0.08); 
          cursor: pointer; 
          border: 1px solid transparent;
          transition: all 0.2s ease;
        }
        .store-item:last-child {
          margin-bottom: 50px;
        }
        
        .store-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 3px 8px rgba(0,0,0,0.12);
        }
        
        .store-item.selected { 
          border: 2px solid #FFAA23; 
          background: #FFF5D6;
        }
        
        .store-name { 
          font-weight: bold; 
          margin-bottom: 5px; 
          font-size: 1em; 
          color: #000;
        }
        
        .store-address { 
          color: #666; 
          margin-bottom: 10px; 
          font-size: 12px; 
        }
        
        .choose-btn { 
          position: absolute;
          right: 15px;
          top: 15px;
          background: #FFAA23; 
          color: black; 
          border: none; 
          padding: 4px 8px; 
          border-radius: 4px; 
          cursor: pointer; 
          font-weight: bold; 
          font-size: 0.85em;
          transition: background-color 0.2s ease; 
          float: right;
        }
        
        .choose-btn:hover {
          opacity: 0.8;
        }
        
        .opening-hours { 
          margin-top: 8px; 
          margin-bottom: 8px;
          font-size: 12px; 
          color: #000; 
        }
        
        .toggle-hours { 
          color: #ff9933; 
          background: none; 
          border: none; 
          cursor: pointer; 
          padding: 0; 
          font-size: 0.85em; 
          display: flex; 
          align-items: center; 
          margin-top: 5px;
          text-align: left;
        }
        
        .toggle-hours .arrow {
          display: inline-block;
          color: #FF9933;
          margin-right: 3px;
        }
        
        .toggle-hours .arrow.up {
          transform: rotate(180deg);
        }
        
        .hours-details { 
          display: none; 
          font-size: 12px;
          color: #666;
          border-radius: 16px;
          background: #ffffff;
          padding: 3px 10px;
          margin-top: 10px;
        }
        
        .hours-details.show { 
          display: block; 
        }
        
        .hours-label, .phone-label {
          color: #666;
          display: inline-block;
        }
        
        .store-selection-confirmation {
          display: none;
          align-items: center;
          background-color: rgba(76, 175, 80, 0.1);
          color: #4CAF50;
          padding: 5px 10px;
          border-radius: 4px;
          margin-top: 10px;
          font-size: 14px;
          animation: fadeIn 0.5s ease-in-out;
        }
        
        .confirmation-icon {
          font-size: 16px;
          margin-right: 8px;
          font-weight: bold;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .selected-marker {
          animation: pulse 1.5s infinite;
        }
        
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;

    // Create HTML structure
    const container = document.createElement("div");
    container.className = "store-picker-container";

    // Store list container
    const storeList = document.createElement("div");
    storeList.className = "store-list";
    storeList.innerHTML = `
        ${this.renderStoresList()}
      `;

    // Map container
    const mapContainer = document.createElement("div");
    mapContainer.className = "map-container";
    mapContainer.innerHTML = '<div id="map"></div>';

    // Add elements to the container
    container.appendChild(storeList);
    container.appendChild(mapContainer);

    // Add everything to Shadow DOM
    this.shadowRoot.appendChild(style);
    this.shadowRoot.appendChild(container);
  }

  // 获取自提点数据
  getPickupPointData() {
    const pickupPointData = document.querySelector("[data-pickup-point]");
    if (pickupPointData) {
      return JSON.parse(pickupPointData.textContent) || [];
    }
    return [];
  }
  // Helper method to render stores list
  // <button class="choose-btn" data-id="${store.id}">Choose this one</button>
  renderStoresList() {
    return this.stores
      .map(
        (store) => `
        <div class="store-item" data-id="${store.id}">
          <div class="store-name">${store.name}</div>
          <div class="store-address">${store.address}</div>
          
          <button class="toggle-hours" data-id="${store.id}">
            <span class="arrow">▼</span> 
            <span class="toggle-text">Öffnungszeiten</span>
          </button>
          <div class="hours-details" id="hours-${store.id}">
            <div class="opening-hours">
              <span class="hours-label">Öffnungszeiten an den verschiedenen Abholstandorten:</span> ${store.hours}
            </div>
            <div>
              <span class="phone-label">Kundensupport:</span> ${store.phone}
            </div>
          </div>
        </div>
      `
      )
      .join("");
  }

  // Set up event listeners
  setupEventListeners() {
    // Toggle hours visibility
    this.shadowRoot.querySelectorAll(".toggle-hours").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const id = e.currentTarget.dataset.id;
        const details = this.shadowRoot.getElementById(`hours-${id}`);
        const arrow = e.currentTarget.querySelector(".arrow");
        const toggleText = e.currentTarget.querySelector(".toggle-text");

        details.classList.toggle("show");

        if (details.classList.contains("show")) {
          arrow.classList.add("up");
          toggleText.textContent = "Öffnungszeiten";
        } else {
          arrow.classList.remove("up");
          toggleText.textContent = "Öffnungszeiten";
        }
      });
    });

    // Store selection via button
    this.shadowRoot.querySelectorAll(".choose-btn").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const id = parseInt(e.target.dataset.id);
        const store = this.stores.find((s) => s.id === id);
        this.selectStore(store);
      });
    });

    // Store selection via item click
    this.shadowRoot.querySelectorAll(".store-item").forEach((item) => {
      item.addEventListener("click", () => {
        const id = parseInt(item.dataset.id);
        const store = this.stores.find((s) => s.id === id);
        this.selectStore(store);
      });
    });
  }

  // Load Google Maps
  loadGoogleMaps() {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD7EZ1-OcNrOrgf6Pbh_K8591byAJ9qboo&callback=initMap`;
    script.async = true;
    window.initMap = () => this.initMap();
    document.head.appendChild(script);
  }

  // Initialize map
  initMap() {
    const mapElement = this.shadowRoot.getElementById("map");
    if (!mapElement) {
      console.error("Map element not found");
      return;
    }

    // 自定义地图样式
    const mapStyles = [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ];

    // 地图配置选项
    const mapOptions = {
      center: { lat: 51.1657, lng: 10.4515 }, // 德国中心
      zoom: 6,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      styles: mapStyles,
    };

    // 创建地图
    this.map = new google.maps.Map(mapElement, mapOptions);

    // 为每个自提点创建标记
    this.stores.forEach((store) => {
      // 创建自定义信息窗口内容
      const infoContent = `
          <div style="padding: 10px; max-width: 200px;">
            <h3 style="margin: 0 0 5px; font-size: 14px;">${store.name}</h3>
            <p style="margin: 0 0 5px; font-size: 12px; color: #666;">${store.address}</p>
            <p style="margin: 0; font-size: 12px; color: #666;">
              <strong>Opening hours:</strong> ${store.hours}
            </p>
          </div>
        `;

      // 创建信息窗口
      const infoWindow = new google.maps.InfoWindow({
        content: infoContent,
        maxWidth: 250,
      });

      // 创建标记
      const marker = new google.maps.Marker({
        position: { lat: store.lat, lng: store.lng },
        map: this.map,
        title: store.name,
        storeId: store.id,
        animation: google.maps.Animation.DROP,
      });

      // 点击标记时选择自提点
      marker.addListener("click", () => {
        this.selectStore(store);

        // 打开信息窗口
        infoWindow.open(this.map, marker);
      });

      // 鼠标悬停时显示信息窗口
      marker.addListener("mouseover", () => {
        infoWindow.open(this.map, marker);
      });

      // 鼠标移开时关闭信息窗口（如果不是选中的标记）
      marker.addListener("mouseout", () => {
        if (this.selectedStore && this.selectedStore.id === store.id) {
          return; // 如果是选中的标记，保持信息窗口打开
        }
        infoWindow.close();
      });

      // 保存标记和信息窗口的引用
      marker.infoWindow = infoWindow;
      this.markers.push(marker);
    });

    // 添加地图边界自适应
    this.fitMapBounds();
  }

  // 使地图自适应所有标记
  fitMapBounds() {
    if (!this.map || this.markers.length === 0) return;

    const bounds = new google.maps.LatLngBounds();
    this.markers.forEach((marker) => {
      bounds.extend(marker.getPosition());
    });

    this.map.fitBounds(bounds);

    // 如果缩放级别太高，限制最大缩放级别
    const listener = google.maps.event.addListener(this.map, "idle", () => {
      if (this.map.getZoom() > 12) {
        this.map.setZoom(12);
      }
      google.maps.event.removeListener(listener);
    });
  }

  // 选择自提点
  selectStore(store) {
    this.selectedStore = store;

    // 清除所有标记的动画、自定义样式和关闭所有信息窗口
    this.markers.forEach((marker) => {
      marker.setAnimation(null);
      marker.setIcon(null);
      if (marker.infoWindow) {
        marker.infoWindow.close();
      }
    });

    // 获取选中的标记
    const selectedMarker = this.markers.find(
      (marker) => marker.storeId === store.id
    );

    if (selectedMarker) {
      // 设置选中标记的高亮样式
      selectedMarker.setIcon({
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: "#FFAA23",
        fillOpacity: 0.9,
        strokeColor: "#FF8000",
        strokeWeight: 2,
        scale: 10,
      });

      // 添加短暂的弹跳动画，然后停止
      selectedMarker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => {
        selectedMarker.setAnimation(null);
      }, 1500);

      // 打开选中标记的信息窗口
      if (selectedMarker.infoWindow) {
        selectedMarker.infoWindow.open(this.map, selectedMarker);
      }
    }

    // 平滑地将地图中心移动到选中的标记
    this.map.panTo({ lat: store.lat, lng: store.lng });
    this.map.setZoom(14);

    // 更新列表中的选中状态
    this.shadowRoot.querySelectorAll(".store-item").forEach((item) => {
      item.classList.toggle("selected", parseInt(item.dataset.id) === store.id);
    });

    // 更新表单字段
    this.updateFormFields(store);

    // 分发自定义事件，但不关闭弹窗
    this.dispatchEvent(
      new CustomEvent("store-selected", {
        detail: {
          store,
          keepOpen: true, // 添加标志指示保持弹窗打开
        },
        bubbles: true,
        composed: true,
      })
    );

    // 添加确认消息
    this.showConfirmation(store);

    // 添加选择成功提示（可选）
    this.showToast(`Store selected: ${store.name}`);
  }

  // 显示临时提示消息
  showToast(message) {
    // 创建提示元素
    const toast = document.createElement("div");
    toast.className = "store-picker-toast";
    toast.textContent = message;

    // 添加样式
    toast.style.cssText = `
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        z-index: 1000;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;

    // 添加到地图容器
    const mapContainer = this.shadowRoot.querySelector(".map-container");
    if (mapContainer) {
      mapContainer.appendChild(toast);

      // 显示提示
      setTimeout(() => {
        toast.style.opacity = "1";
      }, 10);

      // 3秒后隐藏并移除
      setTimeout(() => {
        toast.style.opacity = "0";
        setTimeout(() => {
          toast.remove();
        }, 300);
      }, 3000);
    }
  }

  // 显示选择确认消息
  showConfirmation(store) {
    // 查找选中的商店项
    const storeItem = this.shadowRoot.querySelector(
      `.store-item[data-id="${store.id}"]`
    );
    if (!storeItem) return;

    // 移除任何现有的确认消息
    const existingConfirmations = this.shadowRoot.querySelectorAll(
      ".store-selection-confirmation"
    );
    existingConfirmations.forEach((confirmation) => confirmation.remove());

    // 创建确认消息元素
    const confirmation = document.createElement("div");
    confirmation.className = "store-selection-confirmation";
    confirmation.innerHTML = `
        <div class="confirmation-icon">✓</div>
        <div class="confirmation-text">Store selected</div>
      `;

    // 添加确认消息到选中的商店项
    storeItem.appendChild(confirmation);

    // 滚动到选中的商店项
    storeItem.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  // Update form fields with selected store information
  updateFormFields(store) {
    // Find all product forms on the page
    const productForms = document.querySelectorAll("product-form");

    productForms.forEach((form) => {
      // Update store information fields
      const storeIdField = form.querySelector(
        '.pickup-store-attribute[name="attributes[pickup_store_id]"]'
      );
      const storeNameField = form.querySelector(
        '.pickup-store-attribute[name="attributes[pickup_store_name]"]'
      );
      const storeAddressField = form.querySelector(
        '.pickup-store-attribute[name="attributes[pickup_store_address]"]'
      );
      const storePhoneField = form.querySelector(
        '.pickup-store-attribute[name="attributes[pickup_store_phone]"]'
      );
      const storeHoursField = form.querySelector(
        '.pickup-store-attribute[name="attributes[pickup_store_hours]"]'
      );
      const deliveryMethodField = form.querySelector(
        '.delivery-method-attribute[name="attributes[delivery_method]"]'
      );
      const storeVariantIdField = form.querySelector(
        '.pickup-store-variant-attribute[name="attributes[pickup_store_variant_id]"]'
      );

      if (storeIdField) storeIdField.value = store.id;
      if (storeNameField) storeNameField.value = store.name;
      if (storeAddressField) storeAddressField.value = store.address;
      if (storePhoneField) storePhoneField.value = store.phone;
      if (storeHoursField) storeHoursField.value = store.hours;
      if (deliveryMethodField) deliveryMethodField.value = "pickup";
      if (storeVariantIdField) storeVariantIdField.value = store.variantId;
    });

    // Save selected store variant ID globally for cart addition
    window.selectedPickupStoreVariantId = store.variantId;

    console.log("Updated form fields with store information:", store);
    console.log("Selected pickup store variant ID:", store.variantId);
  }
}

// Register custom element
customElements.define("store-picker", StorePicker);
